document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuButton && mobileNav) menuButton.addEventListener('click', () => { const open = mobileNav.classList.toggle('is-open'); menuButton.setAttribute('aria-expanded', open); });

  const drawer = document.querySelector('[data-cart-drawer]');
  const openDrawer = () => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); body.classList.add('drawer-open'); };
  const closeDrawer = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); body.classList.remove('drawer-open'); };
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeDrawer));

  document.querySelectorAll('[data-add-to-cart]').forEach(button => {
    button.addEventListener('click', async (event) => {
      const form = button.closest('form[data-product-form]');
      if (!form) return;
      event.preventDefault();
      button.disabled = true;
      const formData = new FormData(form);
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: {'Accept':'application/json'}, body: formData });
        if (!response.ok) throw new Error('Unable to add product');
        await fetchCart();
        openDrawer();
      } catch (error) { console.error(error); form.submit(); }
      button.disabled = false;
    });
  });

  async function fetchCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const items = document.querySelector('[data-cart-items]');
    if (items && cart.item_count === 0) items.innerHTML = '<div class="empty-state"><p>Your cart is empty.</p></div>';
  }
});
